<template>
  <article class="fullpage">
    <revenue />
  </article>
</template>

<script>
import { revenue } from '@/components/advisor';
import getBrandConfig from '@/lib/utils/get_brand_config';

const brandConfig = getBrandConfig();

export default {
  head() {
    const title = this.$t('Revenue');
    return {
      title: `${title} | ${brandConfig.fullName}`,
    };
  },
  components: { revenue },
};
</script>
